<template>

    <div :class="['filter-menu', 'filter-' + name ]">

        <div class="filter-label">
            {{ label }}
        </div>

        <div class="flex-grow-1 position-relative">
            <selectize v-model="selectedOption" :settings="settings" />
        </div>

    </div>

</template>

<script>

import FilterMixin from '@/mls-filter/mixins/FilterMixin.js';
import Selectize from '@/mls-filter/components/filters/Selectize.vue';
import { selectizeOptions } from '@/common/selectize.js';
import { startCase } from 'lodash';

export default {

    mixins: [FilterMixin],

    mounted: function() {
        // console.log(this.selectedOption);
    },

    computed: {

        settings() {
            return {
                options: this.options,
                ...selectizeOptions,
            };
        },

        selectedOption: {
            get() {
                return 'B:' + this.$store.state.selected[this.name];
            },
            set(option) {

                if (option) {
                    option = parseInt(option.replace('B:', ''), 10);
                } else {
                    option = null;
                }

                this.$store.dispatch('applyBuilding', {
                    filter: this.name,
                    option,
                });
            },
        },

        /* Display for single select filter */
        display() {
            if (this.selected) {
                return this.selectedOption.name;
            } else {
                return startCase(this.name);
            }
        },

    },

    components: {
        Selectize,
    },
};

// $("#id_building").change(function(ev) {
//     if (this.value) {
//         $("#id_neighborhood").multiselect('deselectAll', true);
//         $("#id_neighborhood").multiselect('deselectAll', false);
//         $("#id_property_type").multiselect('deselectAll', true);
//         $("#id_property_type").multiselect('deselectAll', false);

//         $("#id_neighborhood").multiselect('refresh');
//         $("#id_neighborhood").multiselect('disable');
//         $("#id_property_type").multiselect('refresh');
//         $("#id_property_type").multiselect('disable');

//         $("#id_age_min").prop('disabled', true);
//         $("#id_age_max").prop('disabled', true);
//         $("#id_age_min").val('');
//         $("#id_age_max").val('');

//     } else {
//         $("#id_neighborhood").multiselect('enable');
//         $("#id_property_type").multiselect('enable');
//         $("#id_age_min").prop('enabled', true);
//         $("#id_age_max").prop('enabled', true);
//     }
// });

// $("#id_building").change();

</script>